(() => {
  const instances = new Map();
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-editor-slideshow]')];
    if (scope.matches?.('[data-editor-slideshow]')) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const slides = [...root.querySelectorAll('[data-slideshow-slide]')];
      const dots = [...root.querySelectorAll('[data-slideshow-index]')];
      const pause = root.querySelector('[data-slideshow-pause]');
      const listeners = [];
      let index = 0, timer, paused = false, hovering = false, focused = false, touchX;
      const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      const on = (el, type, fn) => { el.addEventListener(type, fn); listeners.push(() => el.removeEventListener(type, fn)); };
      function schedule() {
        clearInterval(timer); timer = null;
        if (root.dataset.autoplay === 'true' && slides.length > 1 && !paused && !hovering && !focused && !document.hidden && !motion?.matches) {
          timer = setInterval(() => show(index + 1), Math.max(3, Number(root.dataset.interval) || 5) * 1000);
        }
      }
      function show(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause?.()); });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
      on(root, 'click', event => {
        const step = event.target.closest('[data-slideshow-step]'), dot = event.target.closest('[data-slideshow-index]');
        if (step) show(index + Number(step.dataset.slideshowStep));
        if (dot) show(Number(dot.dataset.slideshowIndex));
        if (event.target.closest('[data-slideshow-pause]')) { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); pause.textContent = paused ? 'Reanudar' : 'Pausar'; }
        schedule();
      });
      on(root, 'keydown', event => {
        if (event.target.matches('input,textarea,select,video')) return;
        const next = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: slides.length - 1 }[event.key];
        if (next !== undefined) { event.preventDefault(); show(next); schedule(); }
      });
      on(root, 'mouseenter', () => { hovering = true; schedule(); });
      on(root, 'mouseleave', () => { hovering = false; schedule(); });
      on(root, 'focusin', () => { focused = true; schedule(); });
      on(root, 'focusout', event => { focused = root.contains(event.relatedTarget); schedule(); });
      on(root, 'touchstart', event => { if (!event.target.closest('a,button,video,input')) touchX = event.touches[0].clientX; });
      on(root, 'touchend', event => { if (touchX !== undefined) { const distance = touchX - event.changedTouches[0].clientX; if (Math.abs(distance) > 45) show(index + (distance > 0 ? 1 : -1)); touchX = undefined; schedule(); } });
      on(document, 'visibilitychange', schedule);
      if (motion?.addEventListener) on(motion, 'change', schedule);
      instances.set(root, { select(id) { const i = slides.findIndex(s => s.dataset.blockId === id); if (i >= 0) { paused = true; show(i); schedule(); if (pause) { pause.setAttribute('aria-pressed', 'true'); pause.textContent = 'Reanudar'; } } }, destroy() { clearInterval(timer); listeners.forEach(remove => remove()); instances.delete(root); } });
      show(0); schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { [...instances].forEach(([root, instance]) => { if (event.target === root || event.target.contains(root)) instance.destroy(); }); });
  document.addEventListener('shopify:block:select', event => { instances.forEach(instance => instance.select(event.detail?.blockId)); });
})();
